import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toLower } from 'lodash';
import styled from 'styled-components/macro';

import DataTable from 'components/general/DataTable';
import SearchBarGroup from 'components/general/SearchBarGroup';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const PageTemplate = ({
  data,
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
  handleAdd,
  setModalOpen,
  handleModalOpen,
  setPageNumber,
  setPageSize,
  pageNumber,
  pageSize,
  rowCount,
  to,
  loading,
  setRowSelected,
  toggleMenu,
  enableCopy,
  fetchClinics,
  statusMenuOpen,
}) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const searchPlaceholder = toLower(pathname.split('/')[1]).replace('-', ' ');

  const handleAddButton = () => {
    if (to) {
      history.push(to);
    } else {
      setModalOpen(true);
      handleAdd();
    }
  };

  return (
    <Component>
      <SearchBarGroup
        data={data}
        placeholder={searchPlaceholder}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleAdd={handleAddButton}
        handleModalOpen={handleModalOpen}
      />
      <DataTable
        rows={data}
        columns={columns}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        pageNumber={pageNumber}
        pageSize={pageSize}
        rowCount={rowCount}
        loading={loading}
        setRowSelected={setRowSelected}
        toggleMenu={toggleMenu}
        enableCopy={enableCopy}
        fetchClinics={fetchClinics}
        statusMenuOpen={statusMenuOpen}
      />
    </Component>
  );
};
export default PageTemplate;
